import _ from "lodash";
import {
  APP_FORM_OPTIONS,
  EbiPaymentOptionName,
  IPS_RIDER,
  OPTION_VALUES,
  QuoteOption,
} from "@ipru-common/constants/InputValues";
import {
  APPLICATION_ONE,
  COUNTRY,
  LMS_CONSTANTS,
  SUPER_ADBV,
  SUPER_ATPD,
  SPOUSE_COVER,
  LifeCoverOption,
} from "@ipru-common/constants/SiteConstants";

import { DROPOFF_JSON } from "@ipru-common/constants/dropoffObject";
import { STATES } from "@ipru-common/constants/state";
import {
  heightInCm,
  convertHeight,
  readQueryParams,
  splitFullName,
  generateGaVisitorID,
  isProductSuper,
  getProductDetail,
  formatDate,
  isProductIps,
  isProductIWish,
  isIwishAndDependent,
  changeUrlForLocalMachines,
  isProductIPrime,
  getIPSPlanType,
  getExtra4Riders,
} from "@ipru-common/utils/CommonFunctions";
import { calculatePayoutDetails, getCiTerm, getLifeCoverSection } from "@ipru-common/utils/QuoteCommonFunctions";

const useDropOffDataMapping = () => {
  const yesNo = (val) => (val ? "Yes" : val === OPTION_VALUES.FALSE ? "No" : "");

  const abroadYear = (year, month) => {
    if (year && month) {
      return `${year} year ${month} month`;
    }
  };

  function addMissingKeys(jsonA, jsonB) {
    for (let key in jsonA) {
      // Use Object.prototype.hasOwnProperty.call() and check for undefined
      if (!Object.prototype.hasOwnProperty.call(jsonB, key) || jsonB[key] === undefined) {
        // Add or update the key-value pair from jsonA to jsonB
        jsonB[key] = jsonA[key];
      }
    }
    return jsonB;
  }

  const mapDropOffData = (data = {}) => {
    const {
      existingCustDetails,
      resumeDropOffJourney,
      UID: AppUID,
      appFormData: {
        transactionId = "",
        appNO = "",
        CkycJson = DROPOFF_JSON.CkycJson,
        Ekyc = DROPOFF_JSON.Ekyc,
        partnerSuccess = false,
        healthDetailTab,
        isNorthStarFlow,
        formWizard: {
          personalDetails: pDetails,
          occupationDetails,
          nomineeDetails,
          healthDetails,
          payoutDetails = null,
          proposerDetails = null,
          proposerOccupation = null,
          occupationalActivityHazard,
          habits,
          proposerHealth,
        },
      },
      calculatorFormData,
      quoteFormData,
      spouseCover,
      appointmentData,
      promotionalDiscount,
      isTdPersonaJourney,
      stageCompleted,
    } = data;

    const is_i_dep = isIwishAndDependent(calculatorFormData);

    const queryParams = readQueryParams();

    let UID = AppUID || queryParams.get("UID") || "480";
    if (
      (promotionalDiscount &&
        promotionalDiscount?.responseCode &&
        promotionalDiscount?.responseCode != "Y" &&
        promotionalDiscount?.responseCode != "P") ||
      (calculatorFormData?.promo_code &&
        calculatorFormData?.promo_code != "" &&
        existingCustDetails &&
        existingCustDetails?.CLIENT_ID === "Available")
    ) {
      UID = 1160;
    }
    if (promotionalDiscount?.isApplied && !promotionalDiscount?.isAppliedFromQData) {
      UID = 56539;
    }

    let productSelection = DROPOFF_JSON.productSelection;
    let personalDetails = DROPOFF_JSON["appform-details"];
    let Communication = DROPOFF_JSON.Communication;
    let Nominee = DROPOFF_JSON.Nominee;
    let Health = DROPOFF_JSON.Health;
    let Payout;

    const {
      breakupDetail,
      lumpSumAmt,
      ADB_SA,
      CI_SA,
      user_dob,
      paymentOption,
      payoutType,
      age,
      term,
      ppt,
      tenure,
      monthlyIncomePayoutYears,
      income_duration,
      monthlyIncomeAmt,
      lumpSumAndIncomeYears,
      lumpSumIncomeSingleInst,
      planType,
      nri,
      gender,
      tobacco,
      emailid,
      mobileno,
      calc_occupation,
      city,
      trai_flag,
      // tobacco_acceptance,
      is_icici_employee,
      country = COUNTRY,
      // country_code,
      // do_not_share_detail,
      is_nri_in_india,
      // is_nri_in_india_answered,
      nri_india_arriving_date,
      state,
      employeeId,
      // empName,
      // empFirstName,
      // empLastName,
      calc_education,
      pincode,
      yr_income,
      city_list,
      wifeDetail,
      proposer_dob,
      proposer_yr_income,
      proposer_occupation,
      calc_language,
      ATPD_SA,
      educationLoan,
      loanAmount,
      parentDob,
      parentOccupation,
      parentEducation,
      backDateionApplied,
      wop_benefit,
      instituteName,
      courseName,
    } = { ...quoteFormData, ...calculatorFormData };

    let cityList = { city_list };

    let NRI = {};

    let emailAddress = emailid;

    let existingCustomer = { clientId: "", details: DROPOFF_JSON["existingCust-details"] };

    let whatsapp_optin = OPTION_VALUES.NRI_YES;

    const userIsStudent = calc_occupation === OPTION_VALUES.OCCUPATION.STUDENT;

    const getMyProfession = (prof, self) => {
      if (prof) return prof;
      if (self) {
        switch (self) {
          case OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA:
            return OPTION_VALUES.OCCUPATION.CA;
          case OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR:
            return OPTION_VALUES.OCCUPATION.DOCTOR;
          case OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER:
            return OPTION_VALUES.OCCUPATION.LAWYER;
          case OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT:
            return OPTION_VALUES.OCCUPATION.OTHER;
          case OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT:
            return OPTION_VALUES.OCCUPATION.OTHER;
          default:
            return "";
        }
      }
      return "";
    };

    const productDetail = getProductDetail();

    const PLAN_TYPE = getIPSPlanType(
      quoteFormData?.eligibleForSmartExit?.eligible,
      spouseCover,
      breakupDetail?.companionDiscount,
      quoteFormData?.backDateionApplied
    );

    if (existingCustDetails) {
      const { clientId, ...restDetails } = existingCustDetails;
      existingCustomer = { clientId, details: { ...existingCustomer.details, ...restDetails } };
    }
    // Basic product selection details without quoteFormData
    productSelection = {
      age: age?.toString(),
      AnnualIncome: yr_income,
      dependentFlag: "N",
      dob: user_dob,
      EmailId: emailid,
      employeeId: employeeId,
      gender: gender,
      isStaff: is_icici_employee ? "1" : "0",
      MobileNo: mobileno,
      occupation: calc_occupation,
      productId: productDetail?.code,
      productName: productDetail?.name,
      productType: "TRADITIONAL",
      relations: "",
      salesChannel: "BOL",
      useTobacco: tobacco === OPTION_VALUES.TOBACCO_CONSUMER_YES ? "1" : "0",
      annualpremium: "",
      ADHB: "0",
      ADHBterm: 0,
      CIBenefit: "0",
      CIterm: 0,
      clientId: "",
      proposerDob: proposer_dob,
      proposerOccupation: proposer_occupation,
      proposerIncome: proposer_yr_income,
      LifeCoverOption: isProductIps() ? getLifeCoverSection(quoteFormData?.adb_selected) : LifeCoverOption[planType],
      lms_nri: nri,
      modalPremium: "",
      option: "Lump-Sum",
      policyCommencementDate: "",
      policyTerm: (70 - age)?.toString(),
      premium: "0",
      premiumPayingFrequency: "monthly",
      premiumPayingTerm: (70 - age)?.toString(),
      premiumpaymentoption: "Regular Pay",
      sumAssured: "10000000",
      totalPremium: "0",
      traiFlag: trai_flag ? "YES" : "NO",
      youth_express: "No",
      is_nri_in_india: nri === OPTION_VALUES.NRI_YES ? is_nri_in_india : "",
      coverTillAge: quoteFormData?.coverTillAge,
      nri_india_arriving_date: formatDate(nri_india_arriving_date),
      ...(isProductIps() ? { ciMode: quoteFormData?.ciMode } : {}),
      paymentOption: "RP",
      payoutTerm: "0",
    };
    if (quoteFormData) {
      const { payoutTerm, lumpsumPercentage } = calculatePayoutDetails(
        payoutType,
        monthlyIncomePayoutYears,
        lumpSumAmt,
        monthlyIncomeAmt,
        lumpSumAndIncomeYears,
        lumpSumIncomeSingleInst,
        income_duration
      );

      productSelection = {
        ADHB: quoteFormData?.breakupDetail?.adb_selected ? ADB_SA.toString() : "0",
        ADHBterm: term?.toString(),
        age: age?.toString(),
        AnnualIncome: yr_income,
        annualpremium: breakupDetail?.annualPremium?.toString(),
        CIBenefit: quoteFormData?.breakupDetail?.ci_selected ? CI_SA?.toString() : "0",
        ATPD: quoteFormData?.breakupDetail?.atpd_selected ? ATPD_SA?.toString() : "0",
        ATPDterm: term?.toString(),
        CIterm: isProductIps() ? quoteFormData?.ciTerm : getCiTerm(paymentOption, age, ppt, term)?.toString(),
        clientId: existingCustomer?.clientId || "",
        dependentFlag: "N",
        dob: user_dob,
        proposerDob: proposer_dob,
        proposerOccupation: proposer_occupation,
        proposerIncome: proposer_yr_income,
        EmailId: emailid,
        employeeId: employeeId,
        gender: gender,
        isStaff: is_icici_employee ? "1" : "0",
        LifeCoverOption: isProductIps()
          ? getLifeCoverSection(quoteFormData?.adb_selected)
          : isProductIPrime()
            ? "Life"
            : LifeCoverOption[planType],
        lms_nri: nri,
        lumpsumPercentage,
        MobileNo: mobileno,
        modalPremium: "",
        occupation: wifeDetail
          ? wifeDetail.calc_occupation
          : is_icici_employee
            ? OPTION_VALUES.OCCUPATION.IPRU
            : occupationDetails?.occupation || calc_occupation,
        option: QuoteOption[payoutType],
        payoutTerm,
        plantype: PLAN_TYPE,
        ...(spouseCover && {
          spouse_dob: data?.[SPOUSE_COVER]?.calculatorFormData?.user_dob,
          spouse_occ: data?.[SPOUSE_COVER]?.appFormData?.appNO,
        }),
        policyCommencementDate: "",
        policyTerm: term?.toString(),
        premium: breakupDetail?.total?.toString(),
        premiumPayingFrequency: LMS_CONSTANTS[tenure],
        premiumPayingTerm: ppt?.toString(),
        premiumpaymentoption: EbiPaymentOptionName[paymentOption],
        productId: productDetail?.code,
        productName: productDetail?.name,
        productType: "TRADITIONAL",
        relations: "",
        salesChannel: "BOL",
        sumAssured: lumpSumAmt?.toString(),
        totalPremium: breakupDetail?.total?.toString(),
        traiFlag: trai_flag ? "YES" : "NO",
        useTobacco: tobacco === OPTION_VALUES.TOBACCO_CONSUMER_YES ? "1" : "0",
        youth_express:
          existingCustDetails?.CLIENT_ID === "Available"
            ? existingCustDetails?.isPMJJBY
              ? "PMJJBY"
              : existingCustDetails?.isGTDiscount
                ? existingCustDetails?.isGroupLifeDiscount
                  ? "GroupLife"
                  : "GT"
                : "ExistCust_Yes"
            : promotionalDiscount?.isApplied
              ? "Promocode"
              : "ExistCust_No",
        breakupDetail: breakupDetail,
        is_nri_in_india: nri === OPTION_VALUES.NRI_YES ? is_nri_in_india : "",
        coverTillAge: quoteFormData?.coverTillAge,
        nri_india_arriving_date: formatDate(nri_india_arriving_date),
        ...(isProductIps() ? { ciMode: quoteFormData?.ciMode } : {}),
        paymentOption: paymentOption,
        promotionalDiscount: promotionalDiscount,
        ...(userIsStudent ? { educationLoan, loanAmount, parentDob, parentOccupation, parentEducation } : {}),
        backDateionApplied: backDateionApplied,
        eligibleForSmartExit: quoteFormData?.eligibleForSmartExit,
        wop_benefit,
        orgPlanType: planType,
      };

      if (resumeDropOffJourney?.productSelection) {
        productSelection = resumeDropOffJourney?.productSelection;
      }

      Communication = {
        ...Communication,
        pinCode: pincode,
        city: city,
        state: state,
        country: country || COUNTRY,
        prmnt_pinCode: pincode,
        prmnt_city: city,
        prmnt_state: state,
        prmnt_country: pDetails?.per_country || country || COUNTRY,
        mobileNumber: mobileno,
        emailAddress: emailid,
      };

      personalDetails = {
        ...personalDetails,
        education: calc_education,
        occ: calc_occupation,
      };

      Health = {
        ...Health,
        diagnosed_diabetes: quoteFormData.isDiabetic > 0 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
      };

      whatsapp_optin = yesNo(quoteFormData?.wth_option);
    }

    const sourceURL = changeUrlForLocalMachines(window.location.href.split("?")[0]);

    if (pDetails) {
      const { firstName, lastName } = (pDetails.full_name && splitFullName(pDetails.full_name)) || {};

      personalDetails = {
        ...personalDetails,
        frstNm: firstName,
        preferred_identity_proof: pDetails.identity_proof,
        preferred_age_proof: pDetails.age_proof,
        lstNm: lastName,
        mrtlSts: pDetails.marital_status,
        education: pDetails.highest_education,
        politically_exposed_person: pDetails.politically_exposed_person,
        criminal_offence: pDetails.is_criminal_records,
        investigationDtls: pDetails.investigation,
        isThirdPartyPayment: "No",
        selfEmployeedAll: "",
        panNo: pDetails.pan_number,
        is_address_similar_as_husband: pDetails?.is_address_similar_as_husband,
        isHouseWifeBool: pDetails?.isHouseWifeBool,
        iibSection: pDetails?.iibSection,
        iibApiStatus: pDetails?.iibApiStatus,
        iibSectionData: pDetails?.iibSectionData,
        iibPolicies: pDetails?.iibPolicies,
        previousPolicyQuestion1: pDetails?.previousPolicyQuestion1 || "",
        previousPolicyQuestion1Des: pDetails?.previousPolicyQuestion1Des || "",
        previousPolicyQuestion2: pDetails?.previousPolicyQuestion2 || "",
        previousPolicyQuestion2Des: pDetails?.previousPolicyQuestion2Des || "",
      };

      Communication = {
        ...Communication,
        address1: pDetails.address_line_1,
        preferred_address_proof: pDetails.address_proof,
        address2: pDetails.address_line_2,
        address3: pDetails.address_line_3,
        landmark: pDetails.landmark,
        pinCode: pDetails.pincode,
        city: pDetails.city,
        state: pDetails.state,
        country: country,
        addCommunication: pDetails.is_address_similar ? "Yes" : "No",
        prmnt_address1: pDetails.per_address_line_1,
        prmnt_address2: pDetails.per_address_line_2,
        prmnt_address3: pDetails.per_address_line_3,
        prmnt_landmark: pDetails.per_landmark,
        prmnt_pinCode: pDetails.per_pincode,
        prmnt_city: pDetails.per_city,
        prmnt_state: pDetails.per_state,
        prmnt_country: pDetails.per_country,
        mobileNumber: pDetails.mobile_number,
        emailAddress: pDetails.email_id,
      };

      emailAddress = pDetails.email_id;

      const existingPolicies = getExistingPolicies(pDetails.pre_insurance_data);
      let existingHusbandPolicies = {};

      if (
        calc_occupation === OPTION_VALUES.OCCUPATION.HOUSEWIFE ||
        calc_occupation === OPTION_VALUES.OCCUPATION.STUDENT
      )
        existingHusbandPolicies =
          pDetails?.husband_pre_insurance === OPTION_VALUES.Y_YES
            ? getExistingHusbandPolicies(pDetails?.husband_pre_insurance_data)
            : {};

      Nominee = {
        ...Nominee,
        isEIAOpted: is_i_dep ? proposerDetails?.is_existing_eia : pDetails.is_existing_eia,
        EIAAccountNumber: is_i_dep ? proposerDetails?.eia_number : pDetails.eia_number,
        eiaInsuranceRepository: is_i_dep ? proposerDetails?.insurance_repository : pDetails.insurance_repository,
        insuranceInfos: _.isEmpty(existingPolicies, true) ? "No" : "Yes",
        ...existingPolicies,
        ...existingHusbandPolicies,
      };

      if (pDetails?.city_list?.length > 0) cityList = { city_list: pDetails?.city_list };

      NRI = {
        add_tin_country3: yesNo(pDetails?.tinPAN2),
        bankType: pDetails?.nri_bank_account_type,
        gstWaiver: pDetails?.nri_gst_waiver,
        birth_country: pDetails?.nri_birth_country_india,
        country_birth: pDetails?.nri_birth_country,
        ...(pDetails?.nri_pio_oci === OPTION_VALUES.PIO_OCI.PIO_CI
          ? {
              country_nationality: pDetails?.nri_country_nationality,
              countryOfResidence: pDetails?.nri_country_residence,
              dateOfArrivingIndia: pDetails?.nri_arriving_india_date,
              dateOfLeavingIndia: pDetails?.nri_leaving_india_date,
              nri_stay_abroad_duration: abroadYear(pDetails?.nri_duration_years, pDetails?.nri_duration_months),
              DurationAbroad: "",
              DurationAbroad_month: "",
              nameOfEmployer: pDetails?.nri_employer_details,
              passportNo: pDetails?.nri_passport,
              purposeOfStay: pDetails?.nri_stay_abroad_purpose,
            }
          : {
              country_nationality_fn: pDetails?.nri_country_nationality,
              countryOfResidence_fn: pDetails?.nri_country_residence,
              dateOfArrivingIndia_fn: pDetails?.nri_arriving_india_date,
              dateOfLeavingIndia_fn: pDetails?.nri_leaving_india_date,
              nri_stay_abroad_duration_fn: abroadYear(pDetails?.nri_duration_years, pDetails?.nri_duration_months),
              DurationAbroad_fn: "",
              DurationAbroad_month_fn: "",
              nameOfEmployer_fn: pDetails?.nri_employer_details,
              passportNo_fn: pDetails?.nri_passport,
              purposeOfStay_fn: pDetails?.nri_stay_abroad_purpose,
            }),
        nationality_status: pDetails?.nri_nationality_status,
        non_indian: "",
        NRI_AC_No: "",
        nri_intended_duration: abroadYear(
          pDetails?.nri_intended_duration_years,
          pDetails?.nri_intended_duration_months
        ),
        pio: pDetails?.nri_pio_oci,
        place_birth: "",
        resident_status: "",
        tax_resi: "No",
        tin_country1: pDetails?.tin_issuing_country_1,
        tin_country2: pDetails?.nri_pan_issuing_country,
        tin_country3: pDetails?.nri_pan_issuing_country_2,
        tinNum1: pDetails?.pan_number,
        tinNum2: pDetails?.nri_pan,
        tinNum3: pDetails?.nri_pan_2,
      };

      Health = {
        ...Health,
        nameOfCountry0: pDetails?.nri_country_name,
        city0: pDetails?.nri_city_name,
        visaType0: pDetails?.nri_visa_type,
        purposeOfTravel0: pDetails?.nri_travel_purpose,
        typeOfResidence0: pDetails?.nri_residence_type,
        modeOfTravel: pDetails?.nri_travel_mode,
        arrivalDate0: pDetails?.nri_arrival_date,
        departureDate0: pDetails?.nri_departure_date,
        natureOfBusiness: pDetails?.nri_business_nature,
        safetyPrecaution: pDetails?.nri_employer_precaution,
        travelInLast1Year: yesNo(pDetails?.travelled_abroad),
        travelCount: pDetails?.travelCount,
        nri_country_name_2: pDetails?.nri_country_name_2,
        nri_city_name_2: pDetails?.nri_city_name_2,
        nri_visa_type_2: pDetails?.nri_visa_type_2,
        nri_travel_purpose_2: pDetails?.nri_travel_purpose_2,
        nri_residence_type_2: pDetails?.nri_residence_type_2,
        nri_travel_mode_2: pDetails?.nri_travel_mode_2,
        nri_arrival_date_2: pDetails?.nri_arrival_date_2,
        nri_departure_date_2: pDetails?.nri_departure_date_2,
        nri_business_nature_2: pDetails?.nri_business_nature_2,
        nri_employer_precaution_2: pDetails?.nri_employer_precaution_2,
        nri_country_name_3: pDetails?.nri_country_name_3,
        nri_city_name_3: pDetails?.nri_city_name_3,
        nri_visa_type_3: pDetails?.nri_visa_type_3,
        nri_travel_purpose_3: pDetails?.nri_travel_purpose_3,
        nri_residence_type_3: pDetails?.nri_residence_type_3,
        nri_travel_mode_3: pDetails?.nri_travel_mode_3,
        nri_arrival_date_3: pDetails?.nri_arrival_date_3,
        nri_departure_date_3: pDetails?.nri_departure_date_3,
        nri_business_nature_3: pDetails?.nri_business_nature_3,
        nri_employer_precaution_3: pDetails?.nri_employer_precaution_3,
      };
    }

    if (occupationDetails) {
      const {
        occupation,
        organisation_name,
        organisation_type,
        others_organisation_type,
        self_employed,
        my_profession,
        nameOfOrgDesc,
      } = occupationDetails;

      personalDetails = {
        ...personalDetails,
        occ: self_employed || occupation,
        occDesc: "",
        nameOfOrg: nameOfOrgDesc ? nameOfOrgDesc : organisation_name,
        orgType: organisation_type,
        orgTypeDesc: others_organisation_type,
        myProfession: getMyProfession(my_profession, self_employed),
        orgNameDesc: nameOfOrgDesc,
        annIncme: occupationDetails.annual_income,
        indsTypeQuestion: occupationDetails.indsTypeQuestion,
        indsType: occupationDetails.indsType,
        indsTypeDesc: occupationDetails?.indsTypeOthers || "",
      };
    }

    let mwpa_bene_data = {};

    for (let i = 0; i < 6; i++) {
      const full_name_words = pDetails?.mwpa_data?.[i]?.full_name_mwpa?.trim().split(" ") || [];

      const isSingleWord = full_name_words.length === 1;

      mwpa_bene_data = {
        ...mwpa_bene_data,

        [`bene_fname${i + 1}`]: isSingleWord ? full_name_words[0] || "" : full_name_words.slice(0, -1).join(" ") || "",

        [`bene_lname${i + 1}`]: isSingleWord ? "" : full_name_words[full_name_words.length - 1] || "",

        [`bene_dob${i + 1}`]: pDetails?.mwpa_data?.[i]?.dob_mwpa || "",
        [`bene_reln${i + 1}`]: pDetails?.mwpa_data?.[i]?.relation_mwpa || "",
        [`bene_share${i + 1}`]: pDetails?.mwpa_data?.[i]?.share_mwpa || "",
      };
    }

    const bene_no = pDetails?.mwpa_data?.length;

    mwpa_bene_data = {
      ...mwpa_bene_data,
      add_bene1: bene_no > 1 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
      add_bene2: bene_no > 2 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
      add_bene3: bene_no > 3 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
      add_bene4: bene_no > 4 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
      add_bene5: bene_no > 5 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    };

    let Nominee_Mwpa = {};

    if (pDetails) {
      Nominee_Mwpa = {
        marriedProtectAct: yesNo(pDetails.is_mwpa),
        trust_type1: pDetails.trustee_type,
        trust_name1: pDetails.trustee_name,
        trust_address1: pDetails.trustee_address,
        trust_city1: pDetails.trustee_city,
        trust_state1: isNaN(pDetails.trustee_state)
          ? pDetails.trustee_state
          : STATES.find((state) => state.id == pDetails.trustee_state)?.name || "",
        trust_pincode1: pDetails.trustee_pincode,
        trust_dob1:
          pDetails.trustee_type == OPTION_VALUES.TRUSTEE_TYPE.INDIVIDUAL ? pDetails.trustee_dob : pDetails.trustee_doi,
        trust_pancard1: pDetails.trustee_pan,
        trust_mobileNo1: pDetails.trustee_mobile,
        trust_emailadd1: pDetails.trustee_email,
        trusteeNameofBankAccountHolder: pDetails.trustee_acc_name,
        trusteeBankName: pDetails.trustee_acc_bank,
        trusteeBankAccountNumber: pDetails.trustee_acc_num,
        trusteeaccounttype: pDetails.trustee_acc_type,
        trusteeMICR: pDetails.trustee_acc_micr,
        trusteeIFSC: pDetails.trustee_acc_ifsc,

        ...mwpa_bene_data,
      };
    }

    if (nomineeDetails) {
      const relation =
        nomineeDetails.nominee_relationship === OPTION_VALUES.NOMINEE_RELATIONSHIP.OTHERS
          ? nomineeDetails.nominee_relationship_others
          : nomineeDetails.nominee_relationship;

      Nominee = {
        ...Nominee,
        marriedProtectAct: "No",
        nomineefrstNm: nomineeDetails.nominee_first_name,
        nomineelstNm: nomineeDetails.nominee_last_name,
        nomineeGender: setApointeeNomineegender(relation),
        relationship: relation,
        nomineeDob: nomineeDetails.nominee_dob,
        appointeefrstNm: nomineeDetails.appointee_first_name,
        appointeelstNm: nomineeDetails.appointee_last_name,
        appointeeGender: setApointeeNomineegender(nomineeDetails.appointee_relationship),
        appointeeRelationship: nomineeDetails.appointee_relationship,
        appointeeDob: nomineeDetails.appointee_dob,
        reasonNonBloodRelation: nomineeDetails.nominee_non_blood,
        otherReasonForNonBloodRelation: nomineeDetails.nominee_reason_text,
        relationshipOthers: nomineeDetails.nominee_relationship_others,
        nomineeMobile: nomineeDetails.nominee_mobile,
        nomineeEmail: nomineeDetails.nominee_email,
        appointeeMobile: nomineeDetails.appointee_mobile,
        appointeeEmail: nomineeDetails.appointee_email,
        nominees: nomineeDetails.nominees,
        is_multiple_nominee: nomineeDetails.is_multiple_nominee,
      };
    }

    if (healthDetails) {
      Health = {
        ...Health,
        HQ07: yesNo(healthDetails.narcotics),
        HQ05: yesNo(healthDetails.tobacco),
        tobacco_consumedAs: healthDetails.tobacco_consumed,
        tobacco_quantity: healthDetails.tobacco_per_day,
        tobacco_years: healthDetails.tobacco_years,
        HQ06: yesNo(healthDetails.alcohol),
        alcohol_consumedAs: healthDetails.alcohol_consumed,
        alcohol_quantity: healthDetails.alcohol_per_day,
        alcohol_years: healthDetails.alcohol_years,
        HQ125: yesNo(healthDetails.armedForces),
        HQ09: yesNo(healthDetails.hazardousOccupation),
        weight: healthDetails.weight,
        HQ01: convertHeight(healthDetails.height_feet, healthDetails.height_inches),
        height_cm: heightInCm(healthDetails.height_feet, healthDetails.height_inches),
        HQ167_All_Fields: yesNo(healthDetails.showHealthDiseasesFollowUp),
        diagnosed_bp: yesNo(healthDetails.heartAilments),
        diagnosed_hk: yesNo(healthDetails.chestPain),
        diagnosed_hsurgery: yesNo(healthDetails.heartSurgery),
        diagnosed_diabetes: yesNo(healthDetails.diabetes),
        diagnosed_resp: yesNo(healthDetails.respiratoryDisorders),
        diagnosed_stroke: yesNo(healthDetails.nervousDisorders),
        diagnosed_gastro: yesNo(healthDetails.gastrointestinalIssues),
        diagnosed_liver: yesNo(healthDetails.gastroLiver),
        diagnosed_kidney: yesNo(healthDetails.genitourinaryDisorders),
        diagnosed_cancer: yesNo(healthDetails.cancerHistory),
        diagnosed_hiv: yesNo(healthDetails.hivInfection),
        diagnosed_blood: yesNo(healthDetails.bloodDisorders),
        diagnosed_mental: yesNo(healthDetails.psychiatricIllness),
        diagnosed_other: yesNo(healthDetails.anyOtherDisorder),
        HQ24: yesNo(healthDetails?.seriousInjury),
        HQ21: yesNo(healthDetails.congenitalDefects),
        HQ165: yesNo(healthDetails.familyHistory),
        HQ166: yesNo(healthDetails.medicalHistory),
        HQ144: yesNo(healthDetails.weightLoss),
        HQ188_All: yesNo(healthDetails.showHealthDiseasesFollowUp),
        HQ168: yesNo(healthDetails.gynaecological),
        ...(isProductIWish()
          ? {
              HQ201: yesNo(healthDetails?.HQ201),
              HQ202: yesNo(healthDetails?.HQ202),
              HQ206: yesNo(healthDetails?.HQ206),
              iWishQuestions: healthDetails?.iWishQuestions,
            }
          : {}),
        healthDec_medicalCondt: healthDetails.condition_name,
        healthDec_diagnosis: healthDetails.diagnosis_date,
        healthDec_duration: healthDetails.treatment_duration,
        healthDec_currentState: healthDetails.current_state,
        healthDec_details: healthDetails.treatment_details,
        healthDec_treatment: healthDetails.treatment_tests,
        healthDec_otherDetails: healthDetails.additional_treatment_details,
        remarks: healthDetails.remarks,
        HQ61: yesNo(healthDetails.pregnant),
        pregnancyWeeks: healthDetails.pregnancyWeeks,
      };
    }

    Payout = {
      accHolderName: payoutDetails?.acc_holder_name,
      accNo: payoutDetails?.bank_acc_no,
      ifscCode: payoutDetails?.ifsc_code,
      micrCode: payoutDetails?.micr_code,
      bankName: payoutDetails?.bank_name,
      accType: payoutDetails?.acc_type,
    };

    // if (personalHealth) {
    //   Health = {
    //     ...Health,
    //     healthDec: yesNo(personalHealth.signs_symptoms),
    //     HQ61: yesNo(personalHealth.pregnant),
    //     CHQ14: yesNo(healthDetails.hivInfection),
    //   };
    // }

    let dropOffData = {
      ...DROPOFF_JSON,
      "appform-details": addMissingKeys(DROPOFF_JSON["appform-details"], personalDetails),
      "existingCust-details": existingCustomer.details,
      existingCustomer: existingCustDetails ? "Yes" : "No",
      Communication: addMissingKeys(DROPOFF_JSON.Communication, Communication),
      productSelection,
      pageName: calculatorFormData?.pageName,
      lms_nri: nri === OPTION_VALUES.NRI_YES ? "NRI" : "",
      country_code: pDetails?.mobile_code || "",
      Nominee: addMissingKeys(DROPOFF_JSON?.Nominee, { ...Nominee, ...Nominee_Mwpa }),
      ...(isIwishAndDependent(calculatorFormData)
        ? {
            Proposer: {
              proposerDetails: proposerDetails || {},
              proposerOccupation: proposerOccupation || {
                occupation: productSelection?.proposerOccupation,
                annual_income: productSelection?.proposerIncome,
              },
            },
          }
        : {}),
      ...(isProductIWish()
        ? {
            lifeAssuredFor: calculatorFormData?.lifeAssuredFor,
          }
        : {}),
      Health,
      occupationalActivityHazard,
      habits,
      proposerHealth,
      ...(isProductIWish() ? { Payout } : {}),
      Ekyc,
      ...(nri === OPTION_VALUES.NRI_YES ? { NRI } : {}),
      CkycJson,
      appNO,
      app: "aem",
      partnerSuccess,
      UID,
      gavisitorid: generateGaVisitorID(),
      emailAddress,
      language: calc_language,
      instituteName,
      courseName,
      sourceURL,
      whatsapp_optin,
      ...(occupationDetails?.annual_income ? { professionalCTA: "yes" } : { personalCTA: "yes", sentCampaign: "Y" }),
      ...cityList,
      ...(appointmentData?.pref_datetimenew || appointmentData?.pref_datetimenew == ""
        ? {
            pref_datetimenew: appointmentData.pref_datetimenew,
          }
        : {}),
      isTdPersonaJourney,
      matchtype: "",
      plantype: PLAN_TYPE,
      extra1: "",
      extra2: "",
      extra3: stageCompleted || "",
      extra4: getExtra4Riders(quoteFormData?.breakupDetail),
      extra5: "",
      extra6: "",
      husbandDetail: calculatorFormData?.husbandDetail || {},
      healthDetailTab,
      isNorthStarFlow,
    };

    if (transactionId) {
      dropOffData = { ...dropOffData, transactionId };
    }

    if (isProductSuper() && productSelection?.breakupDetail?.riders?.length > 0) {
      const [rider1, rider2] = productSelection.breakupDetail.riders;
      const { adb_selected, ci_selected } = productSelection.breakupDetail;

      let data = {
        rider1name: "",
        rider1sumassured: "",
        rider1term: "",
        rider1premium: "",
        rider2name: "",
        rider2sumassured: "",
        rider2term: "",
        rider2premium: "",
      };
      if (ci_selected && adb_selected) {
        data = {
          ...data,
          rider1name: SUPER_ADBV,
          rider1sumassured: rider1?.SA,
          rider1term: rider1?.Term,
          rider1premium: rider1?.Premium,
          rider2name: SUPER_ATPD,
          rider2sumassured: rider2?.SA,
          rider2term: rider2?.Term,
          rider2premium: rider2?.Premium,
        };
      } else if (adb_selected) {
        data = {
          ...data,
          rider1name: SUPER_ADBV,
          rider1sumassured: rider1?.SA,
          rider1term: rider1?.Term,
          rider1premium: rider1?.Premium,
        };
      } else if (ci_selected) {
        data = {
          ...data,
          rider1name: SUPER_ATPD,
          rider1sumassured: rider2?.SA,
          rider1term: rider2?.Term,
          rider1premium: rider2?.Premium,
        };
      }
      dropOffData = {
        ...dropOffData,
        ...data,
      };
    }

    if (isProductIps()) {
      dropOffData = {
        ...dropOffData,
        rider1name: productSelection?.breakupDetail?.wop_selected
          ? IPS_RIDER.WOP
          : productSelection?.breakupDetail?.atpd_selected
            ? IPS_RIDER.ATPD
            : IPS_RIDER.ADB,
        rider1sumassured: productSelection?.breakupDetail?.wop_selected
          ? productSelection?.breakupDetail?.premiumSecondYear
          : productSelection?.breakupDetail?.atpd_selected
            ? productSelection?.ATPD
            : productSelection?.ADHB,
        rider1term: productSelection?.ADHBterm,
        rider1premium: productSelection?.breakupDetail?.wop_selected
          ? productSelection?.breakupDetail?.wopPremium
          : productSelection?.breakupDetail?.atpd_selected
            ? productSelection?.breakupDetail?.atpdPremium
            : productSelection?.breakupDetail?.adhbPremium,
        rider2name: productSelection?.breakupDetail?.ci_selected
          ? productSelection?.ciMode === OPTION_VALUES.CI_MODES.CLASSIC.years
            ? IPS_RIDER.CICL
            : IPS_RIDER.CICM
          : "",
        rider2sumassured: productSelection?.breakupDetail?.ci_selected ? productSelection?.CIBenefit : "",
        rider2term: productSelection?.breakupDetail?.ci_selected ? productSelection?.CIterm : 0,
        rider2premium: productSelection?.breakupDetail?.ci_selected ? productSelection?.breakupDetail?.ciPremium : 0,
      };
    }

    return dropOffData;
  };

  const mapDropOffDataWithSpouse = ({ data, appName }) => {
    const husband = mapDropOffData(data);
    const wife = mapDropOffData({ ...data, ...data?.[SPOUSE_COVER], [SPOUSE_COVER]: data });

    if (appName === APPLICATION_ONE) {
      return { ...husband, [SPOUSE_COVER]: wife };
    } else {
      return { ...wife, [SPOUSE_COVER]: husband };
    }
  };

  return { mapDropOffData, mapDropOffDataWithSpouse };
};

function setApointeeNomineegender(relation) {
  const relationArr = [
    "Father",
    "Husband",
    "Grand Father",
    "Grand Son",
    "Nephew",
    "Son",
    "Uncle",
    "Brother",
    "Brother in law",
  ];
  return relationArr.includes(relation) ? "Male" : "Female";
}

function getExistingPolicies(insurancePolicies) {
  let existingPolicies = {};
  if (insurancePolicies?.length > 0) {
    if (insurancePolicies[0].policy_name) {
      for (let index = 1; index <= 5; index++) {
        const policy = insurancePolicies?.[index - 1];

        existingPolicies = {
          ...existingPolicies,
          [`cmpany${index}`]: "",
          [`compnyothers${index}`]: "",
          [`addPolicy${index}`]: "",
          [`sum${index}`]: "",
        };

        if (index > 1 && insurancePolicies?.length > 1) {
          existingPolicies = { ...existingPolicies };
        }

        if (policy) {
          existingPolicies[`cmpany${index}`] = policy.policy_name;
          existingPolicies[`sum${index}`] = policy.life_assured_amount;

          existingPolicies[`compnyothers${index}`] = policy.other_policy_name;

          if (policy.policy_name === APP_FORM_OPTIONS.POLICY_COMPANIES.OTHERS) {
            existingPolicies[`compnyothers${index}`] = policy.other_policy_name;
          }

          if (index > 1 && insurancePolicies?.length > 1) {
            existingPolicies[`addPolicy${index - 1}`] = "Yes";
          }
        }
      }
    }
  }

  return existingPolicies;
}

function getExistingHusbandPolicies(insurancePolicies) {
  let existingPolicies = {};
  if (insurancePolicies?.length > 0) {
    if (insurancePolicies[0].policy_name) {
      for (let index = 1; index <= 5; index++) {
        const policy = insurancePolicies?.[index - 1];

        existingPolicies = {
          ...existingPolicies,
          [`hcmpany${index}`]: "",
          [`hcmpanyothers${index}`]: "",
          [`haddPolicy${index}`]: "",
          [`hsum${index}`]: "",
        };

        if (index > 1 && insurancePolicies?.length > 1) {
          existingPolicies = { ...existingPolicies };
        }

        if (policy) {
          existingPolicies[`hcmpany${index}`] = policy.policy_name;
          existingPolicies[`hsum${index}`] = policy.life_assured_amount;

          existingPolicies[`hcmpanyothers${index}`] = policy.other_policy_name;

          if (policy.policy_name === APP_FORM_OPTIONS.POLICY_COMPANIES.OTHERS) {
            existingPolicies[`hcmpanyothers${index}`] = policy.other_policy_name;
          }

          if (index === insurancePolicies?.length) {
            existingPolicies[`haddPolicy${index}`] = OPTION_VALUES.NRI_NO;
          } else {
            existingPolicies[`haddPolicy${index}`] = OPTION_VALUES.NRI_YES;
          }
        }
      }
    }
    existingPolicies = { ...existingPolicies, HusbandinsuranceInfos: OPTION_VALUES.NRI_YES };
  }

  return existingPolicies;
}

export default useDropOffDataMapping;
